import React from "react";

import styles from "./AuthorizationModal.module.scss";

export const FormsContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.formsContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const RowsContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.rowsContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Row: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.row} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const ButtonRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.buttonRow} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
